import React, { useRef, useEffect } from 'react';

import "./ModalContentWrapper.scss";

const ModalContentWrapper = (props) =>
{
    const refContainer = useRef(null);

    useEffect(() => {
        refContainer.current.scrollTop = 0;
    }, []);

    const isScrollBottomHandlerRequired = () =>
    {
        return props.onScrollBottomReached !== undefined ;
    }

    const handleScroll = (e) =>
    {
        const diff = parseInt((+e.target.scrollHeight - +e.target.scrollTop),10) ;

        const bottom = ( +diff + 1 === e.target.clientHeight || +diff === e.target.clientHeight );

        if ( bottom && props.onScrollBottomReached !== undefined )
        {
            props.onScrollBottomReached();
        }
    }

    const handler = isScrollBottomHandlerRequired() ? handleScroll : null ;

    const innerClassName = props.className === undefined ? "s360-modal-content" : "s360-modal-content " + props.className ;

    const style = props.width !== undefined ? { width: props.width } : {} ;

    return (
        <div ref={refContainer} style={style} className={innerClassName} onScroll={handler}>
                { props.children }
        </div>

    )
}

export default ModalContentWrapper ;